<template>
  <div v-if="plate">
    <v-checkbox
      v-model="plate.isNeedProtect"
      label="Would you like to be protected immediately?"
      :error="$v.plate.isNeedProtect.$error"
    />

    <v-radio-group v-model="plate.protect" class="radio-questions my-4" column>
      <v-radio label="Yes" :value="true" />
      <v-radio label="No" :value="false" />
    </v-radio-group>

    <div v-if="!plate.protect">
      That's OK, I know this is important it'll pay off all the other bills.
      What day of the month works best for you?
    </div>

    <template v-if="plate.protect">
      <v-checkbox
        v-model="plate.isAccount"
        label="Perfect, will be using a checking account, or a debit/credit card?"
        :error="$v.plate.isAccount.$error"
      />

      <div class="d-flex justify-center">
        <v-btn-toggle class="my-2" v-model="bankDetails.isDraft">
          <v-btn :value="true">Bank draft</v-btn>
          <v-btn :value="false">Debit/Credit</v-btn>
        </v-btn-toggle>
      </div>

      <div class="col-4" v-if="bankDetails.isDraft">
        <v-text-field
          v-model="bankDetails.draft.name"
          class="my-2"
          label="Name of the bank"
          hide-details
          :error="$v.bankDetails.draft.name.$error"
        />

        <v-text-field
          v-model="bankDetails.draft.routing"
          class="my-2"
          label="Routing Number"
          hide-details
          :error="$v.bankDetails.draft.routing.$error"
        />

        <v-text-field
          v-model="bankDetails.draft.account"
          class="my-2"
          label="Account Number"
          hide-details
          :error="$v.bankDetails.draft.account.$error"
        />
      </div>

      <div class="col-8" v-else>
        <v-text-field
          v-model="bankDetails.card.card"
          class="col my-2"
          label="Card number"
          :error="$v.bankDetails.card.card.$error"
          hide-details
        />

        <div class="d-flex">
          <v-text-field
            v-model="bankDetails.card.expirationMonth"
            :error="$v.bankDetails.card.expirationMonth.$error"
            class="col-6"
            label="MM"
            v-mask="'##'"
            hide-details
          />

          <v-text-field
            v-model="bankDetails.card.expirationYear"
            :error="$v.bankDetails.card.expirationYear.$error"
            class="col-6"
            label="YY"
            v-mask="'##'"
            hide-details
          />
        </div>

        <v-text-field
          v-model="bankDetails.card.security"
          :error="$v.bankDetails.card.security.$error"
          class="col-6 my-2"
          label="Security code"
          hide-details
        />

        <v-text-field
          v-model="bankDetails.card.zip"
          :error="$v.bankDetails.card.zip.$error"
          class="col-6 my-2"
          label="Billing Zip Code"
          hide-details
        />
      </div>
    </template>

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps } from '@/common/variables';
import { isChecked } from '@/common/helpers';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentPlate',
  components: { PlateFooter },
  computed: {
    ...mapGetters({ bankDetails: 'plates/bankDetails' }),
  },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  data() {
    return {
      plate: null,
      isLoading: false,
    };
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.payment
    );
    this.plate = data;
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.beneficiary);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.summary);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
    draftRequired(val) {
      if (this.bankDetails.isDraft && this.plate.protect) return required(val);
      return true;
    },
    cardRequired(val) {
      if (!this.bankDetails.isDraft && this.plate.protect) return required(val);
      return true;
    },
  },
  validations() {
    return {
      plate: {
        isNeedProtect: { checked: isChecked },
        isAccount: {
          checked: function (val) {
            if (this.plate.protect) return isChecked(val);
            return true;
          },
        },
      },
      bankDetails: {
        draft: {
          name: { required: this.draftRequired },
          routing: { required: this.draftRequired },
          account: { required: this.draftRequired },
        },
        card: {
          card: { required: this.cardRequired },
          expirationMonth: { required: this.cardRequired },
          expirationYear: { required: this.cardRequired },
          security: { required: this.cardRequired },
          zip: { required: this.cardRequired },
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.form-input {
  padding: 0 !important;
  margin: 0 0 0 1em !important;
}

.beneficiary {
  min-height: 270px;
}

.radio-questions {
  .v-input--radio-group__input {
    width: auto !important;
  }

  .v-input__slot {
    justify-content: center;
  }
}

.toggle-error button {
  color: #ff5252 !important;
  border-color: #ff5252 !important;
}

.form-input {
  padding: 0 !important;
  margin: 0 0 0 1em !important;
}

.expiration-row {
  display: flex;
  gap: 20px;
}
</style>